import React from "react";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { Grid, Typography, Skeleton } from "@mui/material";
import { ExpenseClaimsSummaryDTO } from "src/models/expense-claims-summary/expense-claims-summary-dto";
import { numberWithApostrophe } from "src/utils/time-utils";

const MyTeamOpenTravelAndExpensesLink = ({
  customSummary,
  loading,
}: {
  customSummary: ExpenseClaimsSummaryDTO;
  loading: boolean;
}) => {
  const { t } = useTranslation();
  const tRP = "components.custom_widget_links.my_team_travel_and_expenses";
  const theme = useTheme();
  return (
    <>
      <Grid
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          width: "100%",
          color: theme.palette.primary.main,
        }}
      >
        {loading ? (
          <Grid
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <Skeleton
              variant="rounded"
              width="100px"
            />
            <Skeleton
              variant="rounded"
              width="100px"
            />
            <Skeleton
              variant="rounded"
              width="100px"
            />
          </Grid>
        ) : (
          <React.Fragment>
            <Grid style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <Typography variant="h5">
                <b>{customSummary.pendingExpenses ?? 0}</b>{" "}
              </Typography>
              <Typography>{`${t(`${tRP}.report`)}`}</Typography>
            </Grid>

            <Grid style={{ display: "flex", alignItems: "baseline", gap: "5px" }}>
              <Typography variant="h5">
                <b>{numberWithApostrophe(customSummary.pendingAmount ?? 0)}</b>
              </Typography>
              <Typography>{customSummary.currency?.code}</Typography>
            </Grid>

            <Typography variant="h5">
              <b>{`${t(`${tRP}.open`)}`}</b>
            </Typography>
          </React.Fragment>
        )}
      </Grid>
    </>
  );
};
export default MyTeamOpenTravelAndExpensesLink;
